var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalP3SmartPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4336 4.93359H15.7669C13.3737 4.93359 11.4336 6.87369 11.4336 9.26693V43.9336C11.4336 46.3268 13.3737 48.2669 15.7669 48.2669H37.4336C39.8268 48.2669 41.7669 46.3268 41.7669 43.9336V9.26693C41.7669 6.87369 39.8268 4.93359 37.4336 4.93359Z",
    stroke: "#FF5368",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5996 39.5996H26.6213",
    stroke: "#FF5368",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalP3SmartPhone);
export default __webpack_public_path__ + "static/media/Digital_P3_SmartPhone.5856bc19a7ad393c9a845f9b1d02f3d6.svg";
export { ForwardRef as ReactComponent };